import SelectBox from "components/Common/SelectBox"
import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"
import "./index.css"
import DateInput from "components/Common/DateInput"

function TabJacket({
  dimension,
  otherDimensions,
  specification,
  field,
  onChangeSpec,
  onChangeDim,
  onChangeOtherDim,
}) {
  return (
    <>
      <Card>
        <CardBody>
          <p>固定枠</p>
          <Row>
            <Col xl={8} sm={12}>
              <Row style={{ overflow: "auto" }}>
                <Col sm={6} className="pe-0">
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">店舗</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">種別</p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div>
                              <Input
                                disabled
                                className="me-2 me-xl-1"
                                type="radio"
                              />
                              <Label className="mb-0">Bespoke</Label>
                            </div>

                            <div className="ms-5 ms-xl-3">
                              <Input
                                disabled
                                className="me-2 me-xl-1"
                                type="radio"
                              />
                              <Label className="mb-0">MTM</Label>
                            </div>
                            <div className="ms-5 ms-xl-3">
                              <Input
                                disabled
                                className="me-2 me-xl-1"
                                type="radio"
                              />
                              <Label className="mb-0">RTW</Label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">仮縫い</p>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div>
                              <Input disabled className="me-2" type="radio" />
                              <Label className="mb-0">あり</Label>
                            </div>

                            <div className="ms-5">
                              <Input disabled className="me-2" type="radio" />
                              <Label className="mb-0">なし</Label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">仮縫い日</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">納期日</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>
                          <p className="mb-0">出来上日</p>
                        </td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                <Col sm={6} className="ps-0">
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                顧客名
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 132 }}>
                              <Input disabled type="checkbox" />
                              <Label className="ms-2 mb-0">ゲスト</Label>
                            </div>

                            <input
                              placeholder="ゲスト名を入力"
                              style={{ height: 33 }}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                受注日
                              </Label>
                            </div>

                            <DateInput
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                担当者
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 5 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                プライス税抜
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ padding: 6 }}>
                          <div className="d-flex justify-content-around align-items-center">
                            <div className="d-flex" style={{ width: 100 }}>
                              <Label
                                style={{ width: 109 }}
                                className="ms-2 mb-0"
                              >
                                プライス税込
                              </Label>
                            </div>

                            <input
                              disabled
                              style={{ height: 33 }}
                              className="form-control"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Col>
            <Col xl={4} sm={6}>
              <Row>
                <Col>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td>
                          下代
                          <br />
                          <small>※直販の場合は上代と同金額です</small>
                        </td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                      <tr>
                        <td>予定納品日</td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                      <tr>
                        <td>ステータス</td>
                        <td style={{ minWidth: 150, padding: 5 }}>
                          <input className="form-control" disabled />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <p>仕様枠</p>

          <Row>
            <Col xl={8} sm={12}>
              <Row>
                <Col sm={6} className="pe-0">
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td style={{ minWidth: 105 }}>生地商社</td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            className="form-control"
                            disabled
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>生地年度</td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            className="form-control"
                            disabled
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>混率</td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            className="form-control"
                            disabled
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>生地巾</td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            className="form-control"
                            disabled
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
                <Col sm={6} className="ps-0">
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td style={{ minWidth: 105 }}>生地</td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>生地シーズン</td>
                        <td style={{ padding: 5 }}>
                          <input
                            disabled
                            style={{ height: 33 }}
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>ランク</td>
                        <td style={{ padding: 5 }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: 105 }}>用尺</td>
                        <td style={{ padding: 5, position: "relative" }}>
                          <input
                            style={{ height: 33 }}
                            disabled
                            className="form-control"
                          />
                          <p
                            style={{
                              position: "absolute",
                              right: 15,
                              top: 10,
                              opacity: 0.5,
                            }}
                          >
                            M
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>

                {field.jacket.specifications.length > 0 ? (
                  field.jacket.specifications.map((v, i) => {
                    return (
                      <Col sm={6} key={v}>
                        <Table bordered>
                          <tbody>
                            <tr>
                              <td>
                                <SelectBox
                                  onChange={e => onChangeSpec(e, i)}
                                  options={specification}
                                  value={specification.find(
                                    s => s.value === (v.formId ?? "")
                                  )}
                                />
                              </td>
                              <td className="px-4">
                                <Row className="gy-3">
                                  {v.format === "プルダウン" ? (
                                    <div
                                      style={{ width: "100%" }}
                                      className="mx-2"
                                    >
                                      <SelectBox
                                        options={v.labels.map(l => ({
                                          label: l.label,
                                          value: l.sequence,
                                        }))}
                                        value={v.labels.filter(
                                          s => s.sequence === v.answer
                                        )}
                                        isDisabled
                                      />
                                    </div>
                                  ) : v.format === "ラジオボタン" ? (
                                    <div className="d-flex">
                                      {v.labels.map(l => {
                                        return (
                                          <div
                                            className="d-flex me-2"
                                            key={l.sequence}
                                          >
                                            <Input
                                              name={`${v.formId}${i}`}
                                              className="me-2"
                                              type="radio"
                                              checked={l.sequence === v.answer}
                                              value={l.sequence}
                                            />
                                            <Label>{l.label}</Label>
                                          </div>
                                        )
                                      })}
                                    </div>
                                  ) : v.format === "TEXT" ? (
                                    <input
                                      className="form-control"
                                      disabled
                                      value={v.item}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    )
                  })
                ) : (
                  <Col sm={6}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>
                            <SelectBox
                              onChange={e => onChangeSpec(e, 0)}
                              options={specification}
                            />
                          </td>
                          <td>
                            <input
                              disabled
                              className="form-control"
                              style={{ opacity: 0 }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <p>寸法枠</p>
          <Row>
            <Col xl={8} sm={12}>
              <Table bordered>
                <tbody>
                  <tr>
                    <td>サイズ</td>
                    <td colSpan={3}>
                      <input
                        className="form-control"
                        disabled
                        placeholder="Tg"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>寸法</td>
                    <td style={{ textAlign: "center" }}>ゲージ寸法</td>
                    <td style={{ textAlign: "center" }}>補正値</td>
                    <td style={{ textAlign: "center" }}>上がる法</td>
                  </tr>
                  {field.jacket.dimensions.length > 0 ? (
                    field.jacket.dimensions.map((v, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <SelectBox
                              options={dimension}
                              name="dimension"
                              onChange={e => onChangeDim(e, i)}
                              value={dimension.find(s => s.value === v.formId)}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              disabled
                              // value={v.formId ? v.item : ""}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              disabled
                              // value={v.formId ? v.sequence : ""}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control"
                              disabled
                              // value={v.formId ? v.frameType : ""}
                            />
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td>
                        <SelectBox
                          options={dimension}
                          name="dimension"
                          onChange={e => onChangeDim(e, 0)}
                        />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                      <td>
                        <input className="form-control" disabled />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="style-4">
        <CardBody>
          <Row style={{ whiteSpace: "nowrap", overflowX: "scroll" }}>
            <Col sm={12} className="d-flex">
              {field.jacket.otherDimensions.length > 0 ? (
                field.jacket.otherDimensions.map((v, i) => {
                  return (
                    <Table
                      bordered
                      style={{
                        minWidth: 255,
                        maxWidth: 255,
                      }}
                      key={i}
                    >
                      <tbody>
                        <tr>
                          <div style={{ padding: 6 }}>
                            <SelectBox
                              options={otherDimensions}
                              onChange={e => onChangeOtherDim(e, i)}
                              value={otherDimensions.filter(
                                s => s.value === v.formId
                              )}
                            />
                          </div>
                        </tr>
                        <tr>
                          <Row className="gy-3">
                            {v.format === "プルダウン" ? (
                              <div style={{ width: "100%" }} className="mx-2">
                                <SelectBox
                                  options={v.labels.map(l => ({
                                    label: l.label,
                                    value: l.sequence,
                                  }))}
                                  value={v.labels.filter(
                                    s => s.sequence === v.answer
                                  )}
                                  isDisabled
                                />
                              </div>
                            ) : v.format === "ラジオボタン" ? (
                              <div className="d-flex">
                                {v.labels.map(l => {
                                  return (
                                    <div
                                      className="d-flex me-2"
                                      key={l.sequence}
                                    >
                                      <Input
                                        name={`${v.formId}${i}`}
                                        className="me-2"
                                        type="radio"
                                        checked={l.sequence === v.answer}
                                        value={l.sequence}
                                      />
                                      <Label>{l.label}</Label>
                                    </div>
                                  )
                                })}
                              </div>
                            ) : v.format === "TEXT" ? (
                              <div style={{ padding: 6 }}>
                                <input
                                  className="form-control"
                                  // value={v.item}
                                  disabled
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </Row>
                        </tr>
                      </tbody>
                    </Table>
                  )
                })
              ) : (
                <div>
                  <Table
                    bordered
                    style={{
                      minWidth: 255,
                      maxWidth: 255,
                    }}
                  >
                    <tbody>
                      <tr>
                        <div style={{ padding: 6 }}>
                          <SelectBox
                            options={otherDimensions}
                            onChange={e => onChangeOtherDim(e, 0)}
                          />
                        </div>
                      </tr>
                      <tr>
                        <div style={{ padding: 6 }}>
                          <input className="form-control" disabled />
                        </div>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  )
}

export default TabJacket
